class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll(
      "input[type='checkbox'], input[type='radio']",
    );
    this.form = this.querySelector("form");
    this.sectionId = this.dataset.sectionId;
    this.collectionContainer = this.closest("#product-grid-section");
    this.closeButton = this.querySelectorAll("[data-close]");
    this.applyCloseButton = this.querySelectorAll("[data-apply-close]");
    this.filterLinks = this.querySelectorAll("[data-filter-link]");
  }

  connectedCallback() {
    this.filterLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const url = new URL(e.currentTarget.href);
        this.fetchCollection(url.href);
      });
    });

    this.inputs.forEach((input) => {
      input.addEventListener("change", (e) => {
        const isRadio = e.currentTarget.type === "radio";
        const isChecked = e.currentTarget.checked;
        const name = e.currentTarget.name;

        if (isRadio) {
          this.form
            .querySelectorAll(`input[type='radio'][name='${name}']`)
            .forEach((peer) => {
              const peerLabel = peer.closest("label");
              if (peerLabel) peerLabel.classList.remove("active");
            });
        }

        const label = e.currentTarget.closest("label");
        if (isChecked) {
          label?.classList.add("active");
        } else {
          label?.classList.remove("active");
        }

        this.handleFilter();
      });
    });

    this.closeButton.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeMobileDrawer();
      });
    });

    this.applyCloseButton.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleFilter();
        this.closeMobileDrawer();
      });
    });

    const filterRadioInputs = this.querySelectorAll(
      "input[type='radio']:not([name='sort_by'])",
    );

    if (filterRadioInputs.length > 0) {
      if (Array.from(filterRadioInputs).some((input) => input.checked)) {
        return;
      }

      filterRadioInputs[0].checked = true;
      const label = filterRadioInputs[0].closest("label");
      label?.classList.add("active");
    }
  }

  closeMobileDrawer() {
    document.body.classList.remove("mobile-filter-open");
    this.dispatchEvent(
      new CustomEvent("mobile-filter:close", { bubbles: true }),
    );
  }

  handleFilter() {
    const searchParams = this.createSearchParams(this.form);
    this.submitForm(searchParams);
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData);
  }

  submitForm(searchParams) {
    const url = new URL(window.location.pathname, window.location.origin);

    searchParams.forEach((value, key) => {
      url.searchParams.append(key, value);
    });

    this.fetchCollection(url.href);
  }

  fetchCollection(url) {
    history.replaceState("", "", url);

    const sectionUrl = new URL(url);
    sectionUrl.searchParams.set("section_id", this.sectionId);

    fetch(sectionUrl.href)
      .then((response) => response.text())
      .then((responseText) => {
        const parsedHTML = new DOMParser().parseFromString(
          responseText,
          "text/html",
        );
        const newContainer = parsedHTML.querySelector("#product-grid-section");

        if (newContainer) {
          this.collectionContainer.innerHTML = newContainer.innerHTML;
        }
        document.dispatchEvent(new CustomEvent("collection:updated"));
      });
  }
}

if (!customElements.get("collection-filters")) {
  customElements.define("collection-filters", CollectionFilters);
}
